import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';  // React 18
import { BrowserRouter } from 'react-router-dom';  // Import BrowserRouter
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';

// Create the root for the application
const root = ReactDOM.createRoot(document.getElementById('root'));

// Wrap your App with BrowserRouter
root.render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
